import React from 'react';
import { pillars, volumes } from '../data/volumes';
export function Volumes() {
  return <section aria-labelledby="volumes-title" className="bg-ocean text-white" data-id="element-340" data-mp="1lvtl49u4fjf2">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "18px",
      paddingBottom: "20px"
    }} data-id="element-341" data-mp="183vjek2qopsx">
        <div className="text-center" data-id="element-342" data-mp="1c4yxb1188bri">
          <p className="text-sm font-semibold text-cyan" data-id="element-343" data-mp="1c60957q2h2aa">THE REALTOR AI PLAYBOOK™ · The 100-Prompt Real Estate AI System</p>
          <h2 id="volumes-title" className="mt-3 font-display text-3xl font-black sm:text-4xl" data-id="element-344" data-mp="1zsykjqzbxk1c">
            The 6-Volume Strategic Playbook
          </h2>
          <ul className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-bold uppercase tracking-[0.16em] text-white/65" data-id="element-345" data-mp="1qtbkp9m90mae">
            {pillars.map((p, i) => <li key={p} className="flex items-center gap-4" data-id="element-346" data-mp="ff7tgb71pc91" data-mpi={i}>
                {i > 0 && <span className="h-1 w-1 rounded-full bg-gold" aria-hidden="true" data-id="element-347" data-mp="fharniicqbou" />}
                {p}
              </li>)}
          </ul>
        </div>

        <div className="mt-12 grid gap-x-14 md:grid-cols-2" data-id="element-348" data-mp="3o7ddb4hzuqna">
          {volumes.map(v => <article key={v.n} className="flex gap-5 border-t border-white/10 py-8" data-id="element-349" data-mp="3j9bt2g8u0la8">
              <span className="font-display text-4xl font-black leading-none text-gold sm:text-5xl" data-id="element-350" data-mp="20ymvqg6sfkh">{String(v.n).padStart(2, '0')}</span>
              <div className="min-w-0" data-id="element-351" data-mp="3t6zz42bw1f7p">
                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-white/50" data-id="element-352" data-mp="3t9chgglk5rla">{v.label}</p>
                <h3 className="mt-1 font-display text-lg font-extrabold" data-id="element-353" data-mp="azk49i9x9ojo">{v.title}</h3>
                <p className="mt-2 text-[15px] font-medium text-cyan" data-id="element-354" data-mp="62a5hc0n80j6">{v.tagline}</p>
                <p className="mt-2 text-sm leading-relaxed text-white/70" data-id="element-355" data-mp="kqwu64c5u4n2">{v.desc}</p>
                <p className="mt-4 inline-flex items-center gap-2 text-xs font-semibold text-white/85" data-id="element-356" data-mp="fto9nx3jhoin">
                  <span className="h-1.5 w-1.5 rounded-full bg-cyan" aria-hidden="true" data-id="element-357" data-mp="tsxqmyzkkmno" />
                  {v.count} specialized prompts
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}